import React from 'react';
import AccountingMasterRegister from './AccountingMasterRegister';

/** 기준정보 — 회계단위등록 */
const AcctUnitRegister = () => <AccountingMasterRegister axis="unit" />;

export default AcctUnitRegister;

